<!-- 二维码制作 -->
<template>
  <div>
    <!-- 筛选项 -->
    <div class="search-box">
      <!-- 状态 -->
      <div class="mr10 mt10">
        <span class="mr5">状态</span>
        <el-select size="small" class="form-width width-340" v-model="queryParams.status" :placeholder="`请选择`" clearable>
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
        </el-select>
      </div>
      <!-- 核销租户 -->
      <div class="mr10 mt10">
        <span class="mr5">核销租户</span>
          <el-cascader
            size="small"
            :before-filter="remoteSearch"
            filterable
            :options="address"
            clearable
            :show-all-levels="false"
            v-model="queryParams.tenant_id"
            :props="{
              label: 'name',
              value: 'code',
              emitPath:false
            }"
            popper-class="cascader-style"
            @expand-change="expandChange"
            >
          </el-cascader>
        <!-- <el-select size="small" class="form-width width-340" v-model="queryParams.tenant_id" :placeholder="`请选择`" clearable filterable>
          <el-option v-for="item in tenantOpts" :key="item.id" :label="item.name" :value="item.id"> </el-option>
        </el-select> -->
      </div>
      <!-- 核销时间 -->
      <div class="mr10 mt10">
        <span class="mr5">核销时间</span>
        <el-date-picker class="width-340" size="small" v-model="queryParams.time" type="datetimerange" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss" :range-separator="`至`" :start-placeholder="`开始日期`" :end-placeholder="`结束日期`" clearable> </el-date-picker>
      </div>
      <!-- 码值 -->
      <div class="mr10 mt10">
        <span class="mr5">码值</span>
        <el-input size="small" class="form-width width-340" v-model="queryParams.code" :placeholder="`请输入`" clearable></el-input>
      </div>
      <div>
        <el-button size="small" class="ml10 mt10" type="primary" @click="search">查询</el-button>
      </div>
      
    </div>
    <!-- 操作按钮 -->
    <div class="mt10 search-line">
      <div>
        <!-- 新建 -->
        <el-button size="small" class="no-border" type="primary" @click="openDialog(`新建`, 'newQR')">新建</el-button>
        <!-- 批量删除 -->
        <el-button size="small" class="ml10 no-border" style="background-color: rgb(255, 68, 68)" type="primary" @click="batchDeletion">批量删除</el-button>
        <!-- 批量打印 -->
        <el-button size="small" class="ml10 no-border" style="background-color: rgb(7, 193, 96)" type="primary" @click="batchPrint">批量打印</el-button>
        <!-- 批量作废 -->
        <el-button size="small" class="ml10 no-border" style="background-color: rgb(194, 128, 255)" type="primary" @click="batchVoid">批量作废</el-button>
        <!-- 批量撤回核销 -->
        <el-button size="small" class="ml10 no-border" style="background-color: rgb(255, 151, 106)" type="primary" @click="batchWithdrawalWriteOffs">批量撤回核销</el-button>
      </div>
      <!-- 核销统计 -->
      <div class="activite-button mr10" @click="writeOffStatistics">核销统计</div>
    </div>
    <!-- 表格 -->
    <el-table class="mt10" ref="multipleTable" border :data="list" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="#" width="55"></el-table-column>
      <el-table-column v-for="item in columns" :label="item.text" :key="item.column" :width="item.width">
        <template slot-scope="scope">
          <!-- 二维码 -->
          <img v-if="item.column == 'code_preview'" @click="showQRCode(scope.row)" :src="`${$utils.generateCode(scope.row.code, 'qrcode')}`" alt="" class="qr-code" />
          <!-- 操作 -->
          <template v-else-if="item.column == 'handle'">
            <!-- 查看 -->
            <el-button type="text" @click="viewByList(scope.row)">
                查看
            </el-button>
            <!-- 刪除 -->
            <el-button type="text" @click="deleteByList(scope.row)">
                删除
            </el-button>
            <!-- 修改 -->
            <el-button type="text" @click="openDialog(`修改二维码`, 'oneEditQRCode', scope.row)">
                修改
            </el-button>
            <!-- 打印 -->
            <el-button type="text" @click="printByList(scope.row)">
                打印
            </el-button>
            <!-- 作废 -->
            <el-button type="text" @click="voidByList(scope.row)" >
                作废
            </el-button>
            <!-- 撤回核销 -->
            <el-button type="text" @click="withdrawalWriteOffs(scope.row)" >
                撤回核销
            </el-button>
          </template>
          <span v-else>{{ scope.row[item.column] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <pagination :queryParams="queryParams" :getList="getList" />

    <!-- 新建二维码弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="1000px">
      <el-form :inline="true" ref="newForm" :rules="rules" :model="form" class="demo-form-inline">
        <!-- 二维码数量 -->
        <el-form-item :label="`二维码数量` + '：'" v-if="functionType != 'oneEditQRCode'" prop="qr_code_number">
          <el-input-number :min="1" class="form-width" v-model="form.qr_code_number"></el-input-number>
        </el-form-item>
        <!-- 标签数量 -->
        <el-form-item :label="`标签数量` + '：'" prop="tag_number">
          <el-input-number :step="100" :min="1" class="form-width" v-model="form.tag_number"></el-input-number>
        </el-form-item>
        <!-- 正偏差 -->
        <!-- <el-form-item :label="`正偏差` + '：'" prop="deviation_rate">
          <el-input class="form-width" v-model="form.deviation_rate" :placeholder="`请输入`"></el-input>
          <span>%</span>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- 关闭 -->
        <el-button @click="dialogVisible = false">关闭</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="dialogSubmitForm(0)">保存</el-button>
        <!-- 打印 -->
        <el-button type="primary" @click="dialogSubmitForm(1)">打印</el-button>
      </span>
    </el-dialog>

    <!-- 核销统计 -->
    <el-dialog :title="`核销统计`" :visible.sync="dialogVisible2" width="1200px">
      <div class="search-line mt20">
        <div class="search-box">
          <!-- 核销租户 -->
          <div>
            <span class="mr5">核销租户</span>
            <el-select class="input200" v-model="writeOffQueryParams.tenant_id" :placeholder="`请选择`">
              <el-option v-for="item in tenantOpts" :key="item.id" :label="item.name" :value="item.id"> </el-option>
            </el-select>
          </div>
          <!-- 核销日期 -->
          <div class="ml10">
            <span class="mr5">核销日期</span>
            <el-date-picker v-model="writeOffQueryParams.time" type="datetimerange" :range-separator="`至`" :start-placeholder="`开始日期`" :end-placeholder="`结束日期`" :default-time="['00:00:00', '23:59:59']" value-format="yyyy-MM-dd HH:mm:ss"> </el-date-picker>
          </div>
        </div>
        <div>
          <!-- 统计 -->
          <el-button class="ml10" type="primary" @click="statisticalQuery">统计</el-button>
          <!-- 导出 -->
          <el-button class="ml10" type="primary" @click="exportList">导出</el-button>
        </div>
      </div>
      <el-table class="mt20" ref="multipleTable" border :data="writeOffList">
        <el-table-column type="index" label="#" width="55"></el-table-column>
        <el-table-column v-for="item in writeOffColumns" :label="item.text" :key="item.column" :width="item.width">
          <template slot-scope="scope">
            <template v-if="item.column == 'handle'">
              <!-- 查看 -->
              <span class="operation" @click="viewDetails(scope.row)">查看</span>
            </template>
            <span v-else>{{ scope.row[item.column] }}</span>
          </template>
        </el-table-column>
      </el-table>
      <pagination :queryParams="writeOffQueryParams" :getList="writeOffStatistics" />
    </el-dialog>

    <!-- 核销统计中的查看按钮 -->
    <el-dialog :title="`查看`" :visible.sync="dialogVisible3" width="1200px">
      <el-table class="mt20" ref="multipleTable" border :data="codeTraceStatDeteList">
        <!-- 序号 -->
        <el-table-column type="index" label="#" width="55"></el-table-column>
        <el-table-column v-for="item in codeTraceStatDeteColumns" :label="item.text" :key="item.column" :width="item.width">
          <template slot-scope="scope">
            <template v-if="item.column == 'code_preview'">
              <img :src="`${$utils.generateCode(scope.row.code, 'qrcode')}`" alt="" class="qr-code" />
            </template>
            <span v-else>{{ scope.row[item.column] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <!-- 列表操作按钮：查看 -->
    <el-dialog :title="`查看`" :visible.sync="dialogVisible5" width="1000px">
      <div style="padding: 10px 30px">
        <div class="list-view mb20">
          <!-- 码值 -->
          <div>
            <span>码值：</span>
            <span>{{ itemDetail.code }}</span>
          </div>
          <!-- 标签数量 -->
          <div>
            <span>标签数量（张）：</span>
            <span>{{ itemDetail.tag_number }}</span>
          </div>
          <!-- 状态 -->
          <div>
            <span>状态：</span>
            <span>{{ itemDetail.status_text }}</span>
          </div>
        </div>
        <div class="list-view mb20">
          <!-- 核销租户 -->
          <div>
            <span>核销租户：</span>
            <span>{{ itemDetail.tenant_name }}</span>
          </div>
          <!-- 核销用户 -->
          <div>
            <span>核销用户：</span>
            <span>{{ itemDetail.check_user_name }}</span>
          </div>
          <!-- 核销时间 -->
          <div>
            <span>核销时间：</span>
            <span>{{ itemDetail.check_time }}</span>
          </div>
        </div>
        <div class="list-view mb20">
          <!-- 二维码预览 -->
          <div>
            <span>二维码预览：</span>
            <img :src="`${$utils.generateCode(itemDetail.code, 'qrcode')}`" alt="" class="qr-code" />
          </div>
          <!-- 正偏差数量 -->
          <div>
            <span>正偏差数量：</span>
            <span>{{ itemDetail.deviation_tag_number }}</span>
          </div>
          <div>
            <span></span>
            <span></span>
          </div>
        </div>
        <div class="dialog-5-close-box">
          <!-- 关闭 -->
          <span class="dialog-5-close" @click="dialogVisible5 = false">关闭</span>
        </div>
      </div>
    </el-dialog>

    <!-- 二维码预览 -->
    <el-dialog :title="`二维码预览`" :visible.sync="dialogVisible4" width="1000px">
      <div style="text-align: center">
        <img v-if="imgQRCode" :src="`${$utils.generateCode(imgQRCode, 'qrcode')}`" alt="" class="qr-code-big" />
        <p class="max-btn">核销 {{ tagNumber }}（张）</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination';
import { codeTrace, codeTraceList, codeTraceDelete, codeTracePrint, codeTraceCancel, codeTraceStatistics, codeTraceStatisticsDetail, getTenantOpts, codeTraceRevokeVerified, codeTraceEdit } from '@/api.js';
import { pageSize } from '@/utils/Config';
import {
  mapGetters
} from 'vuex';
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      queryParams: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0,
      },
      writeOffQueryParams: {
        pageIndex: 1,
        pageSize: pageSize,
        _total: 0,
      },
      dialogVisible: false, // 弹框显示与否
      dialogVisible2: false, // 激活统计的弹框显示与否
      dialogVisible3: false, // 按租户区域的弹框显示与否
      dialogVisible4: false, //二维码预览
      dialogVisible5: false, // 查看列表打印机具体信息弹框显示与否
      imgQRCode: '',
      tagNumber: 0,
      dialogTitle: '',
      form: {
        qr_code_number: 1,
        tag_number: 100,
        // deviation_rate: 0,
      }, //表单
      functionType: '', //打开的弹框是新建的还是修改的？
      rules: {
        qr_code_number: {
          required: true,
          message: `请输入二维码数量`,
          trigger: 'blur',
        },
        tag_number: {
          required: true,
          message: `请输入标签数量`,
          trigger: 'blur',
        },
        // deviation_rate: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (!isNaN(value) && value <= 10 && value>=0) {
        //         callback();
        //       } else {
        //         callback(new Error(`请输入一个不超过10的数字`));
        //       }
        //     },
        //     trigger: 'blur',
        //   },
        // ],
      },
      list: [],
      itemDetail: {},
      columns: [],
      writeOffColumns: [],
      codeTraceStatDeteList: [],
      writeOffList: [],
      codeTraceStatDeteColumns: [],
      tenantOpts: [],

      multipleSelection: [],
      input: '',
      statusOptions: [
        {
          value: 0,
          label: `未打印`,
        },
        {
          value: 1,
          label: `已打印`,
        },
        {
          value: 2,
          label: `已核销`,
        },
        {
          value: 3,
          label: `作废`,
        },
      ],
      value: '',
    };
  },
  computed:{
    ...mapGetters(['addressOptions']),
    address(){
      // 区县下一级列表初始化
      let arr = this.$utils.deepCopy(this.addressOptions)
            // 避免重复做处理
      for (const item of arr) {
        item.code = item.code + 'code'
      }
      for (const province of arr) {
        for (const city of province.children) {
          for (const county of city.children) {
            this.$set(county,'children',[])
          }
        }
      }
      this.tenantOpts.forEach(item => {
        const province = arr.find(i => i.code === item.province + 'code')
        if (province) {
          const city = province.children.find(i => i.code === item.city)
          if (city) {
            const county = city.children.find(i => i.code === item.area)
            if (county) {
              county.children.push({
                name: item.name,
                code: item.id
              })
            }
          }
        }
      })
      return arr
    }
  },
  created() {
    this.getList();
    this.getTenantsOpts();
  },
  methods: {
    // 获取列表数据
    getList() {
      const { pageIndex, pageSize, status, tenant_id, code, time } = this.queryParams;
      const query = {
        page: pageIndex,
        per_page: pageSize,
        status,
        code,
        tenant_id,
        check_start_time: time ? time[0] : undefined,
        check_end_time: time ? time[1] : undefined,
      };
      if (query.status === '') {
        delete query.status;
      }
      this.$request('get', codeTraceList, query).then((res) => {
        if (res) {
          this.list = res.data;
          this.columns = res.columns;
          this.queryParams._total = res.total;
        }
      });
    },

    // 搜索
    search() {
      this.queryParams.pageIndex = 1;
      this.getList();
    },

    // 批量打印
    batchPrint() {
      // 需要判断是否选中了数据
      if (this.multipleSelection.length == 0) {
        this.promptSelectingData(); // 提示选择数据
        return;
      }
      let arr = [];
      let arrPrint = [];
      this.multipleSelection.forEach((item) => {
        arr.push(item.id);
        arrPrint.push({
          imgUrl: this.$utils.generateCode(item.code, 'qrcode'),
          tag_number: item.tag_number,
          size: '78*50',
        });
      });
      this.printHttp(arr, arrPrint);
    },

    // 表格中的打印按钮
    printByList(data) {
      this.printHttp(
        [data.id],
        [
          {
            imgUrl: this.$utils.generateCode(data.code, 'qrcode'),
            tag_number: data.tag_number
          },
        ],
      );
    },

    // 打印网络调用
    printHttp(ids, arrPrint) {
      this.$utils.print(arrPrint, 'createQRCode');
      this.$request('post', codeTracePrint, { ids }).then((res) => {
        if(res){
          this.$message({
            message: `打印成功`,
            type: 'success',
          });
          this.search();
        }
      });
    },

    // 批量作废
    batchVoid() {
      // 需要判断是否选中了数据
      if (this.multipleSelection.length == 0) {
        this.promptSelectingData(); // 提示选择数据
        return;
      }
      let arr = [];
      this.multipleSelection.forEach((item) => {
        if (item.status == 0 || item.status == 1) {
          arr.push(item.id);
        }
      });
      if (arr.length == 0) {
        this.$message({
          message: `已核销或作废的数据不能作废`,
          type: 'warning',
        });
        return;
      }
      this.$confirm(`是否确认批量作废选中的数据`, `提示`, {
        confirmButtonText: `确定`,
        cancelButtonText: `取消`,
        type: 'warning',
      }).then(() => {
        this.voidHttp(arr);
      });
    },

    // 列表中的作废
    voidByList(data) {
      if (data.status == 0 || data.status == 1) {
        this.$confirm(`是否确认作废该数据`, `提示`, {
          confirmButtonText: `确定`,
          cancelButtonText: `取消`,
          type: 'warning',
        }).then(() => {
          this.voidHttp([data.id]);
        });
      } else {
        this.$message({
          message: `已核销或作废的数据不能作废`,
          type: 'warning',
        });
      }
    },

    // 作废的网络请求
    voidHttp(ids) {
      this.$request('post', codeTraceCancel, { ids }).then((res) => {
        if(res){
          this.$message({
            message: `作废成功`,
            type: 'success',
          });
          this.search();
        }
      });
    },

    // 列表页的查看按钮
    viewByList(data) {
      this.dialogVisible5 = true;
      this.itemDetail = data;
    },

    // 核销统计弹框中的查看按钮
    viewDetails(data) {
      this.$request('get', codeTraceStatisticsDetail, {
        tenant_id: data.tenant_id,
        check_date: data.check_date,
      }).then((res) => {
        if(res){
          this.dialogVisible3 = true;
          this.codeTraceStatDeteList = res.data;
          this.codeTraceStatDeteColumns = res.columns;
        }
      });
    },

    // 批量撤回核销
    batchWithdrawalWriteOffs() {
      // 需要判断是否选中了数据
      if (this.multipleSelection.length == 0) {
        this.promptSelectingData(); // 提示选择数据
        return;
      }
      let arr = [];
      this.multipleSelection.forEach((item) => {
        if (item.status == 2) {
          arr.push(item.id);
        }
      });
      if (arr.length == 0) {
        this.$message({
          message: `只能批量撤回已核销的数据`,
          type: 'warning',
        });
        return;
      }
      this.$confirm(`是否确认批量撤回选中的核销数据`, `提示`, {
        confirmButtonText: `确定`,
        cancelButtonText: `取消`,
        type: 'warning',
      }).then(() => {
        this.withdrawalWriteOffsHttp(arr);
      });
    },

    // 列表中的撤回核销
    withdrawalWriteOffs(data) {
      if (data.status == 2) {
        this.$confirm(`是否确认撤回核销`, `提示`, {
          confirmButtonText: `确定`,
          cancelButtonText: `取消`,
          type: 'warning',
        }).then(() => {
          this.withdrawalWriteOffsHttp([data.id]);
        });
      } else {
        this.$message({
          message: `只能撤回已核销的数据`,
          type: 'warning',
        });
      }
    },

    // 撤回核销的网络请求
    withdrawalWriteOffsHttp(ids) {
      this.$request('post', codeTraceRevokeVerified, {
        ids,
      }).then((res) => {
        if (res) {
          this.$message({
            type: 'success',
            message: `撤回核销成功`,
          });
          this.search();
        }
      });
    },

    //批量删除
    batchDeletion() {
      // 需要判断是否选中了数据
      if (this.multipleSelection.length == 0) {
        this.promptSelectingData(); // 提示选择数据
        return;
      }
      let arr = [];
      this.multipleSelection.forEach((item) => {
        if (item.status == 0 || item.status == 1) {
          arr.push(item.id);
        }
      });
      if (arr.length == 0) {
        this.$message({
          message: `已核销或作废的数据不能删除`,
          type: 'warning',
        });
        return;
      }
      this.$confirm(`是否确认删除选择的数据`, `提示`, {
        confirmButtonText: `确定`,
        cancelButtonText: `取消`,
        type: 'warning',
      }).then(() => {
        this.deleteHttp(arr);
      });
    },

    // 列表中的删除按钮
    deleteByList(data) {
      if (data.status == 0 || data.status == 1) {
        this.$confirm(`是否确认该数据删除`, `提示`, {
          confirmButtonText: `确定`,
          cancelButtonText: `取消`,
          type: 'warning',
        }).then(() => {
          this.deleteHttp([data.id]);
        });
      } else {
        this.$message({
          message: `已核销或作废的数据不能删除`,
          type: 'warning',
        });
      }
    },

    // 删除的方法
    deleteHttp(ids) {
      this.$request('post', codeTraceDelete, {
        ids,
      }).then((res) => {
        if (res) {
          this.$message({
            type: 'success',
            message: `删除成功`,
          });
          this.search();
        }
      });
    },

    // 打开弹框
    openDialog(title, functionType, data) {
      this.dialogTitle = title;
      this.functionType = functionType;

      if (functionType == 'oneEditQRCode') {
        if (data.status == 2 || data.status == 3) {
          this.$message({
            type: 'warning',
            message: `已核销或作废的数据不能删除`,
          });
          return;
        }
        //修改
        this.form.tag_number = data.tag_number;
        // this.form.deviation_rate = data.deviation_rate;
        this.editData = data;
      } else if (functionType == 'newQR') {
        //新建
        this.form.qr_code_number = 1;
        this.form.tag_number = 100;
        // this.form.deviation_rate = 0;
      }
      this.dialogVisible = true;
    },

    //提示选择数据
    promptSelectingData() {
      this.$message({
        message: `请选择数据`,
        type: 'warning',
      });
    },

    // 弹框中的提交
    dialogSubmitForm(status) {
      this.$refs.newForm.validate((valid) => {
        if (valid) {
          let url = '';
          let query = {
            tag_number: this.form.tag_number,
            // deviation_rate: Number(this.form.deviation_rate),
            status,
          };
          if (this.functionType == 'newQR') {
            // 新增
            url = codeTrace;
            query.qr_code_number = this.form.qr_code_number;
          } else if (this.functionType == 'oneEditQRCode') {
            //修改
            url = codeTraceEdit.replace('{id}', this.editData.id);
          }
          this.$request('post', url, query).then((res) => {
            if(res){
              this.dialogVisible = false;
              let message = '';
              if (this.functionType == 'newQR') {
                // 新增
                message = `新增成功`;
              } else if (this.functionType == 'oneEditQRCode') {
                //修改
                message = `修改成功`;
              }
              this.$message({
                message,
                type: 'success',
              });
              this.search();
              if (status == 1) {
                //调起打印
                this.saveAndPrint(res.code, this.form.tag_number);
              }
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    // 新增的时候的打印按钮
    saveAndPrint(data, tag_number) {
      let arrPrint = [];
      data.forEach((item) => {
        arrPrint.push({
          imgUrl: this.$utils.generateCode(item, 'qrcode'),
          tag_number: tag_number
        });
      });
      this.$utils.print(arrPrint, 'createQRCode');
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    //核销统计查询
    statisticalQuery() {
      this.writeOffQueryParams.pageIndex = 1;
      this.writeOffStatistics();
    },

    //核销统计
    writeOffStatistics() {
      this.dialogVisible2 = true;
      const { pageIndex, pageSize, tenant_id, time } = this.writeOffQueryParams;
      const query = {
        page: pageIndex,
        per_page: pageSize,
        tenant_id,
        start: time ? time[0] : undefined,
        end: time ? time[1] : undefined,
      };
      this.$request('get', codeTraceStatistics, query).then((res) => {
        if(res){
          this.writeOffList = res.data;
          this.writeOffColumns = res.columns;
          this.writeOffQueryParams._total = res.total;
        }
      });
    },

    // 导出list
    exportList() {
      const { tenant_id, time } = this.writeOffQueryParams;
      const query = {
        tenant_id,
        start: time ? time[0] : undefined,
        end: time ? time[1] : undefined,
        is_export: 1,
      };

      this.$utils.exportFile(codeTraceStatistics, query);
    },

    // 获取租户
    getTenantsOpts(name = null , area = null , province = null , city = null) {
      return this.$request('get', getTenantOpts, { name,province,city,area })
      .then(res => {
        this.tenantOpts = res || []
      })
    },

    // 展示二维码
    showQRCode(item) {
      const { code, tag_number } = item
      this.imgQRCode = code;
      this.tagNumber = tag_number;
      this.dialogVisible4 = true;
    },
    async remoteSearch(value){
      let res = await this.$request('get', getTenantOpts, { name:value })
      this.tenantOpts = res || []
    },
    expandChange(node){
      if (node[2]) {
        this.getTenantsOpts(null,node[2])
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.search-box {
  display: flex;
  flex-wrap: wrap;
}

.search-box > div {
  flex-shrink: 0;
}

.search-input {
  width: 241px;
}
.no-border {
  border: none;
}
.operation {
  color: #00afde;
  cursor: pointer;
}
.form-width {
  width: 160px;
}
.printer-details {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .el-form-item {
    margin-bottom: 0px;
  }
}
.PD-input-width {
  width: 220px;
}
.dialogNum {
  display: inline-block;
  width: 20px;
}
.activite-button {
  color: #00afde;
  border: 1px solid #00afde;
  background-color: #fff;
  text-align: center;
  line-height: 12px;
  height: 30px;
  width: auto;
  padding: 9px 15px;
  border-radius: 5px;
  font-size: 12px;
  cursor: pointer;
}
.list-view {
  display: flex;
  justify-content: space-between;
}
.list-view > div {
  display: flex;
}
.list-view div:nth-child(1) {
  width: 380px;
}
.list-view div:nth-child(2) {
  width: 200px;
}
.list-view div:nth-child(3) {
  width: 240px;
}

.qr-code-box {
  display: flex;
}
.qr-code {
  height: 80px;
  width: 80px;
  // margin-left: 20px;
}
.dialog-5-close-box {
  display: flex;
  justify-content: center;
}
.dialog-5-close {
  cursor: pointer;
  margin-top: 25px;
  margin-bottom: 15px;
  border: 1px solid #000;
  padding: 5px 15px;
  border-radius: 10px;
}
.qr-code-big {
  width: 300px;
  height: 300px;
}
.width-340 {
  width: 340px;
}
</style>
